import { Navigate } from "react-router-dom";

function LoggedOutOnly({ user, children }) {
  if (user) return <Navigate to={"/"} replace />;
  return children;
}

export default LoggedOutOnly;
